import { Block, Button, Text } from '@mote/ui'
import { Dialog } from '@mote/ui/components/DialogV2'
import { useMicrophonePermissionContext } from './MicrophonePermissionContext'

export function MicrophonePermissionErrorDialog(): JSX.Element {
  const microphonePermissionContext = useMicrophonePermissionContext()

  if (microphonePermissionContext.state.status !== 'error') {
    return <></>
  }

  return (
    <Dialog onClose={() => microphonePermissionContext.reset()} isOpen={true}>
      <Dialog.Header>{microphonePermissionContext.state.title}</Dialog.Header>
      <Dialog.Content>
        <Block align='center' gap={16}>
          <Text tag='p' fontSize={14}>
            {microphonePermissionContext.state.message}
          </Text>
        </Block>
      </Dialog.Content>
      <Dialog.Footer>
        <Button
          //@ts-expect-error
          onClick={() => microphonePermissionContext.reset()}
          text={'Dismiss'}
        />
      </Dialog.Footer>
    </Dialog>
  )
}
